import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { MENU_SLUG } from "../../constants/constants";
import ImgFillIcon from "../../icons/imgFillIcon";
import ToolsIcon from "../../icons/toolsIcon";
import CalendarIcon from "../../icons/calendarIcon";
import SettingIcon from "../../icons/settingIcon";
import SubMenu from "./subMenu";
import styles from "./style.module.css";
const menuItems = [
  {
    icon: ImgFillIcon,
    link: MENU_SLUG.snapshot,
  },
  {
    icon: ToolsIcon,
    link: MENU_SLUG.service_history,
  },
  {
    icon: CalendarIcon,
    link: MENU_SLUG.track,
  },
  {
    icon: SettingIcon,
    link: MENU_SLUG.utilities,
    children: [
      {
        title: "Report",
        link: MENU_SLUG.reports,
      },
      {
        title: "Manage Car",
        link: MENU_SLUG.my_cars,
      },
      {
        title: "Set Up Consumables",
        link: `${MENU_SLUG.utilities}/${MENU_SLUG.set_up_consumables}`,
      },
      {
        title: "Checklist",
        link: `${MENU_SLUG.utilities}/${MENU_SLUG.checklist}`,
      },
      {
        title: "Tutorials",
        link: `${MENU_SLUG.utilities}/${MENU_SLUG.tutorials}`,
      },
      {
        title: "Billing",
        link: `${MENU_SLUG.utilities}/${MENU_SLUG.billing}`,
      },
      {
        title: "Contact Us",
        link: `${MENU_SLUG.utilities}/${MENU_SLUG.contact_us}`,
      },
    ],
  },
];

const MobileNav = ({ defaultActive = false, isScrolling }) => {
  return (
    <div
      className={`${styles.mobile_menu} ${
        defaultActive ? styles.defaultActive : ""
      } ${isScrolling ? styles.active : ""}`}
    >
      <div className={styles.mobile_menu_inner}>
        {menuItems.map((item, index) => (
          <Fragment key={index}>
            <div className={styles.mobile_menu_item}>
              {item.children ? (
                <SubMenu item={item} isScrolling={isScrolling} />
              ) : (
                <NavLink to={`/${item.link}`}>
                  <item.icon />
                </NavLink>
              )}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default MobileNav;
